export default __webpack_public_path__ + "static/media/firstimg.21aa0bdf.png";